import { auth } from '@/lib/firebase';
import api from '@/lib/api';

const GET_SUBSCRIBER = 'GET_SUBSCRIBER';

const SET_SUBSCRIBER = 'SET_SUBSCRIBER';

const getDefaultState = () => {
  return {
    subscriber: null,
  }
};

export const state = getDefaultState();

export const mutations = {
  [SET_SUBSCRIBER](state, { subscriber }) {
    state.subscriber = subscriber;
  }
};

export const getters = {
  [GET_SUBSCRIBER](state) {
    return state.subscriber;
  }
}

export const actions = {
  async addSubscriber(_, payload) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.post(
        `/support/add-subscriber`,
        payload,
        { 
          headers: { Authorization: `Bearer ${token}` } 
        }
      );

      return response.data.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async getSubscriber(_, { phone }) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.get(
        '/support/subscriber',
        { 
          params: { phone },
          headers: { Authorization: `Bearer ${token}` } 
        }
      );

      const subscriber = response.data.data[0];

      return subscriber;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async performActions(_, { id, hasSupportCenter }) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.post(
        `/support/performActions/${id}`,
        { hasSupportCenter },
        { 
          headers: { Authorization: `Bearer ${token}` } 
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  }
};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters,
}